module.exports = "/_next/static/images/43c9551279316541f9bd7141ba7717ff-stapler@mobile480.jpg";